import i18n from 'i18next';
import * as yup from 'yup';
import contactsFormSchema from './contactsFormSchema';

const sharedMissionFormSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required(() => i18n.t('common.message.requiredField')),
  jurisdictions: yup.array().of(contactsFormSchema),
  clientId: yup.number(),
});

export default sharedMissionFormSchema;
